import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TimeUtilityService {
  // == METHODS =========================================
  /** Returns how many minutes ago the date was (rounded down). */
  public getDateAge(oldTime: Date): number {
    const now = new Date();
    const ageInMs = now.getTime() - oldTime.getTime();
    const ageInMinutes = ageInMs / (1000 * 60);
    return Math.floor(ageInMinutes);
  }

  /** Creates a string representation of minutes as "[X] min(s)" or "[X]h [Y]m".
   *  @param minutes Should be a positive whole number. */
  public stringifyMinutes(minutes: number): string {
    if (minutes < 60) {
      return minutes + (minutes === 1 ? ' min' : ' mins');
    } else {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      return hours + 'h ' + remainingMinutes + 'm';
    }
  }
}
